import { render, staticRenderFns } from "./copy-to-clipboard-button.vue?vue&type=template&id=691e7c63"
import script from "./copy-to-clipboard-button.vue?vue&type=script&lang=js"
export * from "./copy-to-clipboard-button.vue?vue&type=script&lang=js"
import style0 from "./copy-to-clipboard-button.vue?vue&type=style&index=0&id=691e7c63&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports